// removed by extract-text-webpack-plugin
module.exports = {"landing":"src-pages----landing-module---landing---1T43_","landing__header":"src-pages----landing-module---landing__header---160Ei","btn__wrapper":"src-pages----landing-module---btn__wrapper---HNJ4r","landing__btn":"src-pages----landing-module---landing__btn---3l1u1","landing__btn--alt":"src-pages----landing-module---landing__btn--alt---2RmQX src-pages----landing-module---landing__btn---3l1u1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/landing.module.scss
// module id = 250
// module chunks = 154382131621592